import { render, staticRenderFns } from "./CircleAlias.vue?vue&type=template&id=8ed084ac&"
import script from "./CircleAlias.vue?vue&type=script&lang=js&"
export * from "./CircleAlias.vue?vue&type=script&lang=js&"
import style0 from "./CircleAlias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports